
define('text!presentation/shell/views/shell.html',[],function () { return '<div data-bind="css: shellName,\n                compose: {\n                    model: shellViewModel,\n                    activate: true\n                }">\n</div>\n';});

